<template lang="pug">
.spotlight_card.fw-b
    amount-input-form(
      :is-editable="editAmt"
      :show-form="!continuePayment"
      @edit-amt='editAmt = true'
      @input-amt='amt = $event'
      :userDetails='details',
    )
    .px-3(v-if="editAmt")
      .max-w-300.mx-auto
        el-button(type='success' round
          @click='makeIntent' v-loading='loading').w-100.mb-2 Continue

    .pt-2.bg-gray-100.mb-4(v-if="!continuePayment")
    div(v-show="!editAmt && !continuePayment").bg-white

      .px-20.mb-4.mt-4.fees-title(v-if="showContactInfo") Contact

        el-form(
          ref="refForm"
          :rules="rules"
          :model="unregisterInfo"
          status-icon
          label-position="top"
        )
          el-form-item(label="Email" prop="email")
            el-input(v-model="unregisterInfo.email" v-lowercase-email).input-field-payment

          el-form-item(label="Mobile phone number" prop="phone")
            el-input(
            v-model="unregisterInfo.phone"
              type="tel"
              placeholder="(123) 456-7890"
              v-mask="'(###) ###-####'"
            ).input-field-payment
      .px-20.mb-4.fees-title Payment
        .max-w-350.mx-auto.mt-3
          p.input-filed-title Credit card
          div#payment-element
          div#card-errors.card_errors(role='alert', v-if='hasCardErrors') {{ cardErrors }}
      .pt-2.bg-gray-100.mb-4

      .px-20.py-4
        .max-w-300.mx-auto
          .fs-14.mb-4
            .d-flex.mb-2
              div Your Deposit
              .ms-auto ${{ parseFloat(amt).toFixed(2) }}
            .d-flex.mb-2
              div Platform Fee (2%)
              .ms-auto ${{ convenienceFee.toFixed(2) }}
            .d-flex.mb-2
              div Credit Card Fees (2.9% + ¢30)
              .ms-auto ${{ stripeFee.toFixed(2) }}
            .d-flex
              div Total
              .ms-auto  ${{ (parseFloat(amt) + convenienceFee + stripeFee).toFixed(2) }}
        .max-w-300.mx-auto
          .mb-4.lh-sm
          i.fw-m.fs-12( v-html="walletDepositText")
        .mt-2
          el-button(type='success'
            v-loading='loading'
            round @click="finalizePayment"
            v-if="!hasCardErrors && showPaymentButton").mb-2.donate-button Deposit
      .px-3
        el-button(
          link
          round
          @click.stop='cancelIntent'
          style="display: flex; align-items: center;"
          class="text-muted donate-button"
        ) Cancel

</template>

<script>
import {
  computed,
  ref,
  reactive,
  defineComponent,
  onMounted,
  onUnmounted,
} from 'vue';
import { ElLoading } from 'element-plus';
import { useStore } from 'vuex';
import { mask } from 'vue-the-mask';
import shared from './shared';
import { walletDepositText } from '../../data/payment-text';
import globalShared from '@/shared';
import { email, phone } from '@/data/rules';
import AmountInputForm from './AmountInputForm.vue';
import lowercaseEmail from '@/directives/lowercase-email.js';

export default defineComponent({
  name: 'FinalizePaymentStatic',
  components: { AmountInputForm },
  directives: { mask, lowercaseEmail },
  setup() {
    const {
      loading,
      route,
      requestCanIntent,
      requestCanIntentForOrg,
      requestCanIntentForFollowingGroup,
      requestCreatePaymentIntent,
      requestCreatePaymentIntentForOrg,
      requestCreatePaymentIntentForFollowingGroup,
    } = shared();

    const {
      isWebUser,
    } = route.query;

    const { getMobileOperatingSystem, isSafari, handleSafariPrompt } = globalShared();

    const { userId, orgId, followingGroupId } = route.params;
    const store = useStore();
    const showContactInfo = ref(false);
    const refForm = ref(null);
    const readyToPay = ref(false);
    const hasCardErrors = ref(true);
    const cardErrors = ref('');
    const completeUserInfo = ref(false);
    const unregisterInfo = reactive({
      email: '',
      phone: '',
    });
    let paymentElement;
    let stripe;
    let elements;

    const options = {
      layout: {
        type: 'tabs',
        defaultCollapsed: false,
      },
    };

    const userOrOrg = ref('user');
    const amt = ref(0);
    const fee = ref(0);
    const convenienceFee = ref(0);
    const convenienceFeePercentageValue = ref(0);
    const stripeFee = ref(0);
    const editAmt = ref(true);
    const continuePayment = ref(false);
    const details = reactive({});
    const paymentIntent = reactive({});
    const paymentDetails = reactive({});

    async function getUserIntent() {
      loading.value = true;
      const response = await requestCanIntent(userId);
      Object.assign(details, response);
      loading.value = false;
    }

    async function getOrgIntent() {
      loading.value = true;
      const response = await requestCanIntentForOrg(userId, orgId);
      Object.assign(details, response);
      loading.value = false;
    }

    async function getFollowingGroupIntent() {
      loading.value = true;
      const response = await requestCanIntentForFollowingGroup(userId, followingGroupId);
      Object.assign(details, response);
      loading.value = false;
    }

    function loadStripe(stripeURL, callback) {
      const obj = document.createElement('script');
      const script = document.getElementsByTagName('script')[0];
      obj.src = `//${stripeURL}`;
      if (callback) {
        obj.addEventListener('load', (e) => {
          callback(null, e);
        }, false);
      }
      script.parentNode.insertBefore(obj, script);
    }

    function continueToPayment(e) {
      e.preventDefault();
      continuePayment.value = true;
    }

    function getRedirectUrl() {
      // If this is a web user, return web callback URL
      if (isWebUser === 'true') {
        return `${window.location.origin}/wallet/add-funds`;
      }
      // Otherwise return mobile app URL
      return import.meta.env.VITE_APP_REDIRECT_BASE_URL;
    }

    function getRedirectIOSUrl() {
      return import.meta.env.VITE_APP_REDIRECT_URL;
    }

    function cancelIntent() {
      if (isWebUser === 'true') {
        // For web users, redirect to wallet dashboard
        window.location.href = '/web/wallet/dashboard';
      } else {
        // For mobile app users, use app redirect
        window.location.href = `${getRedirectUrl()}?action=addToWalletCancel`;
      }
    }

    async function validateForm() {
      if (refForm.value) {
        refForm.value.validate(async (valid) => {
          if (valid) {
            completeUserInfo.value = true;
            return true;
          }
          loading.value = false;
          completeUserInfo.value = false;
          return false;
        });
      }
    }

    // _____check if payment button should be shown_____
    const showPaymentButton = computed(() => {
      if (isWebUser !== 'true' || (store.getters['users/me'] != null && unregisterInfo.email === '' && unregisterInfo.phone === '')) {
        return true;
      } if (store.getters['users/me'] === null && unregisterInfo.email !== '' && unregisterInfo.phone !== '') {
        validateForm();
        if (completeUserInfo.value === true) return true;
      } else {
        return false;
      }
    });

    async function finalizePayment(e) {
      validateForm();
      loading.value = true;
      localStorage.setItem('unregisterEmail', unregisterInfo.email);
      localStorage.setItem('unregisterPhone', unregisterInfo.phone);
      e.preventDefault();
      await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: '',
        },
        redirect: 'if_required',
      }).then((result) => {
        const amount = parseFloat(amt.value).toFixed(2);

        if (result.error) {
          // Show error to your customer (for example, insufficient funds)
          console.error('Payment error:', result.error.message);
          document.body.innerHTML = 'An error occurred while adding money to the wallet';

          const redirectUrl = getRedirectUrl();

          if (isWebUser === 'true') {
            window.location.href = `/web/wallet/dashboard?paymentSuccess=false&amount=${amount}`;
          } else {
            window.location.href = `${redirectUrl}/?action=addToWallet&amount=${amount}&success=false`;
          }
        } else if (result.paymentIntent.status === 'succeeded') {
          // Show a success message to your customer
          document.body.innerHTML = 'Thank you for adding money to the wallet';

          if (isWebUser === 'true') {
            // For web users, redirect directly to wallet dashboard with success params
            window.location.href = `/web/wallet/dashboard?paymentSuccess=true&amount=${amount}`;
          } else {
            // For mobile app users, use mobile redirect
            redirectMobileApp();
          }
        } else {
          console.error('Payment status not succeeded:', result.paymentIntent?.status);
          document.body.innerHTML = 'An error occurred while adding money to the wallet';

          const { isWebUser } = route.query;

          if (isWebUser === 'true') {
            const fullUrl = `/web/wallet/dashboard?paymentSuccess=false&amount=${amount}`;
            return window.location.href = fullUrl;
          }

          return redirectMobileApp(true);
        }
      }).finally(() => {
        loading.value = false;
      });
    }

    async function redirectMobileApp(failed = false) {
      const amount = parseFloat(amt.value).toFixed(2);
      const loadingInstance = ElLoading.service({
        lock: false,
      });
      const isAndroid = getMobileOperatingSystem() === 'Android';
      const browserFallbackUrlBase = import.meta.env.VITE_WEB_BASE_URL;
      const browserFallbackUrlPath = 'web/dashboard';
      let query = '';
      if (!failed) {
        query = `?action=addToWallet&amount=${amount}&success=true`;
      } else {
        query = `?action=addToWallet&amount=${amount}&success=${failed}`;
      }

      if (isAndroid) {
        const appId = import.meta.env.VITE_APP_ID;
        const appHost = import.meta.env.VITE_APP_HOST;
        window.location.href = `intent://${appHost}/${query}#Intent;scheme=${appId};package=${appId};end`;
      } else {
        window.location.href = `${getRedirectIOSUrl()}${query}`;
      }

      // Detect if redirect was successful
      let didSafariRedirect = false;
      if (isSafari()) {
        didSafariRedirect = await handleSafariPrompt();
      }

      // we are checking for strong inequality with false, because null indicates that the prompt timed out, not that the redirection was unsuccessful
      // unfortunately this will attempt to redirect the user to the app store if they decline the redirect to the app on Safari
      // currently no better option exists for iOS Safari
      if (!isSafari() || didSafariRedirect !== false) {
        setTimeout(() => {
          // redirect user to the dashboard if the document is hidden (i.e. the app launched successfully)
          if (document.hidden) {
            window.location.href = `${browserFallbackUrlBase}/${browserFallbackUrlPath}`;
            loadingInstance.close();
          }
          // keep user on site to allow redirect with button
          else {
            loadingInstance.close();
          }
        }, 1500);
      }
      // iOS Safari failed redirect
      else {
        loadingInstance.close();
      }
    }

    function calculateFinalPayment(depositAmount) {
      let mTotalAmountWithConvenienceFee = 0;
      let mConvenienceFee = 0;
      const mConvenienceFeePercentageValue = 2.0; // Flat 2% for all transactions

      // Calculate 2% of deposit amount
      mConvenienceFee = parseFloat((0.02 * depositAmount).toFixed(2));

      // Cap convenience fee at $30
      if (mConvenienceFee > 30) {
        mConvenienceFee = 30;
      }

      mTotalAmountWithConvenienceFee = depositAmount + mConvenienceFee;

      // ([Amount] + [Convenience Fee] + [0.30 stripe fixed fee]) / (1 - [2.9 stripe % fee])
      // eslint-disable-next-line max-len
      const totalAmount = parseFloat(((mTotalAmountWithConvenienceFee + 0.30) / (1 - 0.029)).toFixed(2));
      const mStripeFee = parseFloat(totalAmount - mTotalAmountWithConvenienceFee).toFixed(2);

      const result = {
        total_amount: totalAmount,
        deposit_amount: depositAmount,
        convenienceFee: mConvenienceFee,
        convenienceFeePercentageValue: mConvenienceFeePercentageValue,
        creditCardFee: mStripeFee,
      };
      return result;
    }

    async function makeIntent() {
      const amount = parseFloat(parseFloat(amt.value).toFixed(2));
      if (amount > 0) {
        let totalAmount = parseFloat(parseFloat(amount + fee.value).toFixed(2));
        let response = '';
        if (userOrOrg.value === 'user') {
          loading.value = true;
          // convenienceFee.value = parseFloat((0.02 * amount).toFixed(2));
          // stripeFee.value = parseFloat((0.03 * amount).toFixed(2));
          // convenienceFeePercentageValue.value = 2.0;
          const finalPaymentCalculation = calculateFinalPayment(amount);
          convenienceFee.value = finalPaymentCalculation.convenienceFee;
          // eslint-disable-next-line max-len
          stripeFee.value = parseFloat(parseFloat(finalPaymentCalculation.creditCardFee).toFixed(2));
          fee.value = parseFloat(parseFloat(convenienceFee.value + stripeFee.value).toFixed(2));
          totalAmount = parseFloat(parseFloat(amount + fee.value).toFixed(2));
          // eslint-disable-next-line max-len
          convenienceFeePercentageValue.value = finalPaymentCalculation.convenienceFeePercentageValue;
          response = await requestCreatePaymentIntent(
            details.id,
            {
              amount: totalAmount,
              walletDeposit: amount,
              totalFee: fee.value,
              convenienceFee: convenienceFee.value,
              creditCardFee: stripeFee.value,
            },
          );
          loading.value = false;
        } else if (userOrOrg.value === 'org') {
          loading.value = true;
          const finalPaymentCalculation = calculateFinalPayment(amount);
          convenienceFee.value = finalPaymentCalculation.convenienceFee;
          // eslint-disable-next-line max-len
          stripeFee.value = parseFloat(parseFloat(finalPaymentCalculation.creditCardFee).toFixed(2));
          fee.value = parseFloat(parseFloat(convenienceFee.value + stripeFee.value).toFixed(2));
          totalAmount = parseFloat(parseFloat(amount + fee.value).toFixed(2));
          // eslint-disable-next-line max-len
          convenienceFeePercentageValue.value = finalPaymentCalculation.convenienceFeePercentageValue;
          response = await requestCreatePaymentIntentForOrg(
            details.id,
            details.organizationId,
            {
              amount: totalAmount,
              walletDeposit: amount,
              totalFee: fee.value,
              convenienceFee: convenienceFee.value,
              creditCardFee: stripeFee.value,
            },
          );
          loading.value = false;
        } else if (userOrOrg.value === 'followingGroup') {
          loading.value = true;
          const finalPaymentCalculation = calculateFinalPayment(amount);
          convenienceFee.value = finalPaymentCalculation.convenienceFee;
          // eslint-disable-next-line max-len
          stripeFee.value = parseFloat(parseFloat(finalPaymentCalculation.creditCardFee).toFixed(2));
          fee.value = parseFloat(parseFloat(convenienceFee.value + stripeFee.value).toFixed(2));
          totalAmount = parseFloat(parseFloat(amount + fee.value).toFixed(2));
          // eslint-disable-next-line max-len
          convenienceFeePercentageValue.value = finalPaymentCalculation.convenienceFeePercentageValue;
          response = await requestCreatePaymentIntentForFollowingGroup(
            userId,
            followingGroupId,
            {
              amount: totalAmount,
              walletDeposit: amount,
              totalFee: fee.value,
              convenienceFee: convenienceFee.value,
              creditCardFee: stripeFee.value,
            },
            orgId || undefined,
          );
          loading.value = false;
        }
        if (response !== '') {
          Object.assign(paymentDetails, JSON.parse(atob(response)));
          paymentDetails.amount = totalAmount;
          Object.assign(paymentIntent, paymentDetails);
          editAmt.value = false;
          loadStripe('js.stripe.com/v3/', () => {
            stripe = window.Stripe(paymentDetails.stripe_pub_key);
            elements = stripe.elements({ clientSecret: paymentDetails.client_secret });
            paymentElement = elements.create('payment');
            paymentElement.mount('#payment-element');
            paymentElement.on('change', (e) => {
              if (e.complete) {
                readyToPay.value = true;
                hasCardErrors.value = false;
              } else if (e.error) {
                hasCardErrors.value = true;
                readyToPay.value = false;
                cardErrors.value = e.error.message;
              }
            });
          });
        }
      }
    }

    // REMOVED: The viewport resize handler was causing scroll fighting.
    // When user tries to scroll, viewport resize events fire and force scroll back.
    // Instead, we rely on CSS scroll-margin-top and browser's native scroll behavior.

    onMounted(async () => {
      // Viewport resize listener removed to prevent scroll fighting

      if (userId && orgId && followingGroupId) {
        userOrOrg.value = 'followingGroup';
        await getFollowingGroupIntent();
      } else if (userId && followingGroupId) {
        userOrOrg.value = 'followingGroup';
        await getFollowingGroupIntent();
      } else if (userId && orgId) {
        userOrOrg.value = 'org';
        await getOrgIntent();
      } else if (userId && !orgId && !followingGroupId) {
        userOrOrg.value = 'user';
        await getUserIntent();
      } else {
        userOrOrg.value = 'false';
      }
    });

    onUnmounted(() => {
      // Cleanup if needed
    });

    return {
      refForm,
      amt,
      fee,
      convenienceFee,
      stripeFee,
      convenienceFeePercentageValue,
      paymentIntent,
      editAmt,
      continuePayment,
      loading,
      makeIntent,
      requestCanIntent,
      requestCanIntentForOrg,
      readyToPay,
      hasCardErrors,
      cardErrors,
      paymentDetails,
      finalizePayment,
      cancelIntent,
      details,
      continueToPayment,
      walletDepositText,
      validateForm,
      rules: {
        email,
        phone,
      },
      showContactInfo,
      showPaymentButton,
      isWebUser,
    };
  },
});
</script>

<style lang="scss">
.spotlight_card .mt-2 {
  display: flex;
  padding: 0 8px 0 8px;
}

.donate-button {
  margin: 0 auto !important;
  display: block;
}

// Prevent scroll fighting on mobile webviews
#payment-element {
  @media (max-width: 768px) {
    // scroll-margin-top tells the browser how much space to leave above the element
    // when scrolling it into view. This accounts for the app bar at the top.
    scroll-margin-top: 80px;
    scroll-margin-bottom: 20px;
  }
  
  // Ensure the Stripe iframe inside also respects scroll margins
  :deep(iframe) {
    @media (max-width: 768px) {
      scroll-margin-top: 80px;
    }
  }
}

// Ensure payment section has proper spacing for mobile
.fees-title {
  @media (max-width: 768px) {
    scroll-margin-top: 80px;
  }
}
</style>
